export const IMAGES_DIR = 'images';
